import styled, { css } from 'styled-components';
interface StyleProps {
  isModal?: boolean;
  mobileMaxHeight?: string;
  zoomRate?: number;
  mobileZoomRate?: number;
  modalImageMaxHeight?: number;
  mobileDisplay?: string;
  widthPercentage?: number;
  paddingTopPercentage?: number;
  mediaItemsLength?: number;
  shouldCenter?: boolean;
  isDesktopHidden?: boolean;
  urlClass?: string;
}

interface MediaGridProps {
  maxHeight?: string;
  showOverflow?: boolean;
}

export const GalleryWrapper = styled.div<StyleProps>`
  display: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  @media (min-width: 992px) {
    display: ${props => (props.isDesktopHidden ? 'none' : 'flex')};
    flex-direction: column;
    gap: 8px;
    margin: 2rem auto;
    margin-right: 2rem;
  }
`;

export const HeroSection = styled.div<{ urlClass: string }>`
  width: 100%;
  aspect-ratio: 3 / 2;
  overflow: hidden;
  position: relative;
  background: linear-gradient(to bottom, #e5e5e5, #f7f7f7);
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 3rem;
    transform: translateZ(0);
    filter: drop-shadow(20px 24px 14px rgba(0, 0, 0, 0.18));
    transform: translateZ(0);
    ${({ urlClass }) =>
      urlClass === 'remove-shadow' &&
      `
      filter: none;
      mix-blend-mode: darken;
  `}
    cursor: zoom-in;
  }
`;

export const MediaGrid = styled.div<MediaGridProps>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  width: 100%;
  .hide {
    display: none;
  }
`;

export const MediaTile = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  background: linear-gradient(to bottom, #e5e5e5, #f7f7f7);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  padding-top: 133.33%;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

export const MediaImage = styled.img<{ urlClass: string }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) translateZ(0);
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(20px 24px 14px rgba(0, 0, 0, 0.18));
  padding: 2rem;
  cursor: zoom-in;

  ${({ urlClass }) =>
    urlClass === 'rotate-front' &&
    `
      padding: 0;
      transform: translate(-50%, -50%) rotate(-63.5deg) scale(1.25) translateZ(0);
      top: 60%;
  `}

  ${({ urlClass }) =>
    urlClass === 'rotate-back' &&
    `
      transform: translate(-50%, -50%) rotate(67.5deg) scale(1.25) translateZ(0);
      top: 60%;
      padding: 0;
  `}

  ${({ urlClass }) =>
    urlClass === 'remove-padding' &&
    `
      padding: 0;
      object-fit: cover;
  `}
  ${({ urlClass }) =>
    urlClass === 'push-right' &&
    `
      padding: 2rem 0 2rem 2rem;
      transform: translate(-50%, -50%) translateZ(0);
  `}
  ${({ urlClass }) =>
    urlClass === 'remove-shadow' &&
    `
      filter: none;
      mix-blend-mode: darken;
  `}
`;

export const ViewAllMediaButton = styled.button`
  display: inline-flex;
  height: 40px;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 24px;
  background-color: white;
  cursor: pointer;
  font-family: 'Instrument Sans';
  border: none;

  font-family: 'Instrument Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.16px;

  position: absolute;
  bottom: 16px;
  right: 16px;
  &:hover {
    background-color: #e5e5e5;
  }
`;

export const ScrollableContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
  margin-top: 8px;
`;

export const ViewMoreButton = styled.button`
  font-family: 'Instrument Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.14px;
  color: #191a1f;
  border: none;
  background-color: transparent;
  cursor: pointer;

  span {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    &:hover {
      text-decoration: none;
      transition: text-decoration 0.3s ease;
    }
  }
`;

export const CarouselItemsContainer = styled.div<StyleProps>`
  img {
    max-height: ${props => props.modalImageMaxHeight}px;
    min-height: 40px;
  }
`;

export const ProductBadgeContainer = styled.span`
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 1;

  @media screen and (min-width: 992px) {
    display: flex;
  }
`;

export const HeroImageWrapper = styled.div`
  display: flex;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
`;

export const GalleryContainer = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  margin: 2rem -16px;
  overscroll-behavior-x: none;
  @media screen and (min-width: 992px) {
    margin: 2rem 0;
  }
  img {
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
`;

export const GalleryMainContent = styled.div<StyleProps>`
  position: relative;
  width: 100%;
  background-color: transparent;
  background: ${props => (props.isModal ? 'transparent' : 'linear-gradient(to bottom, #e5e5e5, #f7f7f7)')};
  padding-top: 0;
  overflow: ${props => (props.isModal ? '' : 'hidden')};
  @media screen and (min-width: 992px) {
    margin-left: ${props => (props.isModal ? '0' : '60px')};
    margin-top: ${props => (props.isModal ? '0' : '-20px')};
    width: ${props => (props.isModal ? '100%' : 'calc(100% - 60px)')};
  }
  &:hover .video-controls {
    visibility: visible;
  }
  img {
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  @media (min-width: 992px) {
    background: transparent;
  }
`;

export const ModalContainer = styled.div`
  position: relative;
  z-index: 999999999;
`;

export const HeroImage = styled.img<StyleProps>`
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  width: ${props => (props.isModal ? '' : '100%')};
  height: ${props => (props.isModal ? '' : '100%')};
  object-fit: contain;
  cursor: zoom-in;
  transition: transform 0.3s ease;
  resize: none;
  filter: drop-shadow(20px 24px 14px rgba(0, 0, 0, 0.18));
  transform: translateZ(0);
  ${({ urlClass }) =>
      urlClass === 'remove-shadow' &&
      `
      filter: none;
      mix-blend-mode: darken;
  `}

  &.modal-hero-image {
    max-width: 95%;
    position: absolute;
    z-index: 9999;
    cursor: zoom-in;
    transition: transform 0.3s ease;
  }

  &.modal-hero-image.zoomed {
    transform: ${props => (props.mobileZoomRate ? `scale(${props.mobileZoomRate}) translateZ(0)` : '')};
    cursor: zoom-out;
    @media screen and (min-width: 992px) {
      transform: ${props => (props.zoomRate ? `scale(${props.zoomRate}) translateZ(0)` : '')};
    }
  }
  &.modal-hero-image.non-zoomable {
    pointer-events: none;
  }
`;

const thumbListStyle = css<StyleProps>`
  position: absolute;
  bottom: -6rem;
  max-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: ${props => (props.shouldCenter ? 'center' : 'flex-start')};
  padding-left: ${props => (props.shouldCenter ? 'inherit' : '24px')};
  padding-right: ${props => (props.shouldCenter ? 'inherit' : '16px')};
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 0.5rem;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: 992px) {
    top: calc(50% - 4px);
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    bottom: revert;
    overflow-y: auto;
    padding-bottom: 0;
    height: 360px;
    justify-content: ${props => (props.mediaItemsLength && props.mediaItemsLength >= 6 ? 'inherit' : 'center')};
    padding-left: 0;
    padding-right: 0;
    overflow-x: hidden;
  }
`;

export const ThumbnailListBackground = styled.div`
  position: absolute;
  bottom: -7rem;
  left: 0;
  right: 0;
  height: 128px;
  width: 100%;

  &::before {
    content: ' ';
    display: block;
    height: 100%;
  }
  @media screen and (min-width: 992px) {
    display: none !important;
    &::before {
      display: none !important;
    }
  }
`;

const modalThumbListStyle = css<StyleProps>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  gap: 8px;
  overflow-x: auto;
  z-index: 99999;
  margin: 0 2rem;
  justify-content: ${props => (props.shouldCenter ? 'center' : 'flex-start')};
  @media screen and (min-width: 992px) {
   justify-content: ${props => (props.shouldCenter ? 'center' : 'flex-start')};
  }
`;

export const ThumbnailList = styled.div<StyleProps>`
  ${props => (props.isModal ? modalThumbListStyle : thumbListStyle)}
  img {
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
`;

export const VideoThumbnailContainer = styled.div<StyleProps>`
  min-width: 60px;
  height: 60px;
  width: 60px;
  min-height: 60px;
  margin-right: 8px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  margin-bottom: 10px;
  background: linear-gradient(to bottom, #e5e5e5, #f7f7f7);
  border: solid rgba(26, 27, 27, 0.2) 1.2px;

  &:hover {
    border: solid black 1.2px;
  }

  &.activeStyle {
    border-color: black;
    @media screen and (min-width: 992px) {
      background: linear-gradient(to bottom, #e5e5e5, #f7f7f7);
    }
  }

  @media screen and (min-width: 992px) {
    margin-right: 0;
    background: linear-gradient(to bottom, #e5e5e5, #f7f7f7);
  }
`;

export const VideoThumbnail = styled.img<StyleProps>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  cursor: pointer;
`;

export const ImageThumbnailContainer = styled.div<StyleProps>`
  min-width: 60px;
  width: 60px;
  height: 60px;
  min-height: 60px;
  margin-right: 8px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  mix-blend-mode: darken;
  background: linear-gradient(to bottom, #e5e5e5, #f7f7f7);
  border: solid rgba(26, 27, 27, 0.2) 1px;

  &.activeStyle {
    border: ${props => (props.isModal ? 'solid black 1px' : '')};
    border: solid black 1.2px;
    @media screen and (min-width: 992px) {
      background: linear-gradient(to bottom, #e5e5e5, #f7f7f7);
    }
  }

  cursor: pointer;

  &.hidden-xs-down {
    display: none;
    @media screen and (min-width: 992px) {
      display: flex;
    }
  }

  &:hover {
    border: solid black 1.2px;
  }

  @media screen and (min-width: 992px) {
    margin-right: 0;
    background: linear-gradient(to bottom, #e5e5e5, #f7f7f7);
    border-width: 1.2px;
  }
`;

export const ThumbnailImage = styled.img<StyleProps>`
  visibility: visible;
  max-width: 45px;
  max-height: 45px;
  mix-blend-mode: darken;
  cursor: pointer;

  @media screen and (min-width: 992px) {
    visibility: visible;
  }
`;

export const ScrollThumbsDownButton = styled.button`
  cursor: pointer;
  width: 60px;
  padding: 0;
  height: 2rem;
  flex-shrink: 0;
  background-color: transparent;
  position: absolute;
  bottom: calc(50% - 212px);
  border: none;
  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline-width: 0px;
    box-shadow: rgb(185, 205, 241) 0px 0px 0px 3px;
    transition: box-shadow 0.15s ease 0s;
  }

  display: none;
  justify-content: center;
  align-items: center;
  border-radius: 0;

  @media screen and (min-width: 992px) {
    display: flex;
  }
`;

export const ScrollThumbsUpButton = styled.button`
  cursor: pointer;
  width: 60px;
  padding: 0;
  height: 2rem;
  flex-shrink: 0;
  background-color: transparent;
  position: absolute;
  top: calc(50% - 216px);
  border: none;
  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline-width: 0px;
    box-shadow: rgb(185, 205, 241) 0px 0px 0px 3px;
    transition: box-shadow 0.15s ease 0s;
  }

  display: none;
  justify-content: center;
  align-items: center;
  border-radius: 0;

  @media screen and (min-width: 992px) {
    display: flex;
  }
`;

export const ScrollGalleryButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 2rem;
  right: 2rem;
  transform: translateY(-50%);

  .gallery-button {
    background-color: transparent;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
  }
`;

export const LeftScrollButtonWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 2rem;
  transform: translateY(-50%);
  z-index: 1;
  visibility: hidden;

  .gallery-button {
    background-color: transparent;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
  }
  &:hover {
    background-color: #e7e7e7;
    border-radius: 50%;
  }
  @media screen and (min-width: 992px) {
    visibility: visible;
  }
`;

export const RightScrollButtonWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 2rem;
  transform: translateY(-50%);
  z-index: 1;
  visibility: hidden;

  .gallery-button {
    background-color: transparent;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
  }
  &:hover {
    background-color: #e7e7e7;
    border-radius: 50%;
  }
  @media screen and (min-width: 992px) {
    visibility: visible;
  }
`;

export const ArrowScrollButton = styled.button`
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: transparent;
  border: none;
  padding: 0;
  &:hover {
    background-color: #e7e7e7;
    border-radius: 50%;
  }
`;

export const PlayIcon = styled.img<StyleProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 30px;
  height: 30px;
`;

export const IframeWrapper = styled.div<StyleProps>`
  position: relative;
  width: ${props => (props.widthPercentage ? `${props.widthPercentage}%` : '100%')};
  padding-top: ${props => (props.paddingTopPercentage ? `${props.paddingTopPercentage}%` : '56.25%')};
  height: 0;
  grid-column: span 2;

  .iframe-play-icon {
    visibility: visible;
    z-index: 9;
    height: 40px;
    width: 40px;

    @media screen and (min-width: 992px) {
      display: none;
    }
  }
  .show-iframe {
    visibility: visible;
    opacity: 1;
    transition: opacity 300ms 300ms ease-in-out;
  }
  .hide-iframe {
    visibility: hidden;
    opacity: 0;
  }
`;

export const StyledIframe = styled.iframe<StyleProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  z-index: 8;
  display: ${props => (props.mobileDisplay ? props.mobileDisplay : 'block')};
  @media screen and (min-width: 992px) {
    display: block;
  }
`;

export const IframeThumbnailMobile = styled.img`
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;

  @media screen and (min-width: 992px) {
    display: none;
  }
`;

export const IframeThumbnailDesktop = styled.div`
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;

  @media screen and (min-width: 992px) {
    display: block;
  }
`;

export const IframeThumbnailWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  z-index: 7;
  cursor: pointer;
`;

export const IframeLoader = styled.div`
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  z-index: 6;
  margin: -10px 0;
`;

export const ModalContent = styled.div``;

export const ModalGalleryMainContent = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  padding-top: 66.67%;
  height: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  &:hover .video-controls {
    visibility: visible;
  }
`;

export const ThreeSixtyOverlay = styled.div`
  position: absolute;
  background-color: #f9f9f9;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
`;

export const Toggle360 = styled.button`
  position: relative;
  height: 44px;
  width: 44px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px #eee;
  border-radius: 50%;
  background-color: #fff;
  overflow: hidden;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  margin-left: auto;
  cursor: pointer;
  z-index: 1;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline-width: 0px;
    box-shadow: rgb(185, 205, 241) 0px 0px 0px 3px;
    transition: box-shadow 0.15s ease 0s;
  }

  img {
    max-width: 40px;
    max-height: 40px;
  }

  @media screen and (min-width: 992px) {
    margin: 0;
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    right: auto;
  }
`;

export const RightArrowButton = styled.div`
  position: fixed;
  right: 0.5rem;
  bottom: 1.5rem;
  cursor: pointer;
  z-index: 9999;
`;

export const LeftArrowButton = styled.div`
  position: fixed;
  bottom: 1.5rem;
  left: 0.5rem;
  cursor: pointer;
  z-index: 9999;
`;
